module.exports = __webpack_public_path__ + "img/smart-min.ef978873.svg";